import _ from "lodash";
import { sqlInjection } from "../common";
import { emailValidator } from "./email";
import { passwordValidator } from "./password";
import { phoneValidator } from "./phone";
import { postCodeValidator } from "./postcode";
import { websiteValidator } from "./website";
import { abnValidator } from "./abn";
import { firstNameValidator, lastNameValidator } from "./name";
import { hourlyRateValidator } from "./hourlyRate";
import { passwordTypeValidator } from "./passwordType";
import { availableDaysValidator } from "./availableDays";

const { key: pattern } = sqlInjection;


export const ValidateField = ({ value, validation = [] }) => {
    let error = false;
    let valid = true;
    for (const iterator of validation) {
        let type = iterator;
        // let type_value = '';
        if (typeof iterator != 'string') {
            type = iterator['type'];
            // type_value = iterator['value'];
        }
        switch (type) {
            case ValidatorTypes.REQUIRED:
                if (!_.isBoolean(value) && !value) return { error: "This Field is Required", valid: false };
                break;
            case ValidatorTypes.EMAIL:
                if (value) {
                    let status = emailValidator(value);
                    if (!status) return { error: "Please Enter Valid Email", valid: false };
                }
                break;
            case ValidatorTypes.PHONE_NUMBER:
                if (value) {
                    let status = phoneValidator(value);
                    if (!status) return { error: "Please Enter Valid Mobile Number" };
                }
                break;
            case ValidatorTypes.ABN:
                if (value) {
                    value = value.trim();
                    let { valid, error } = abnValidator(value.replace(/ /g, ''));
                    return { error, valid };
                }
                break;
            case ValidatorTypes.POSTCODE:
                if (value) {
                    const { valid, error } = postCodeValidator(value)
                    return { error, valid };
                }
                break;
            case ValidatorTypes.PAYMENT_TERMS:
                if (value >= 0) {
                    return { error: false, valid: true };
                } else if (value < 0) return { error: 'Should be greater than 0', valid: false };
                break;
            case ValidatorTypes.TEXTAREA:
                if (value) {
                    if (value.trim().replace(/ /g, '').length < 2) return { error: 'This field should be atleast 2 characters long', valid: false }
                    else if (value.length > 3000) return { error: 'Maximum limit of 3000 characters exceed.', valid: false };
                }
                break;
            case ValidatorTypes.MIN_TWO_CHARACTERS:
                if (value) {
                    const trimmed = String(value).trim();
                    if (trimmed.length < 2) {
                        return { error: "This field should be at least 2 characters long", valid: false };
                    }
                }
                break;
            case ValidatorTypes.FILE:
                if (iterator.max && _.isArray(value) && value.length > iterator.max) return { error: `You Can not Upload more than ${iterator.max} files`, valid: false };
                else if (iterator.min && _.isArray(value) && value.length < iterator.min) return { error: `Upload alteast ${iterator.min} files`, valid: false };
                else return { error: `Please upload files.`, valid: false };
            case ValidatorTypes.MIN:
                if (value) {
                    if (isNaN(value) || Number(value) < 0) return { error: "Should be greater then 0!", valid: false }
                }
                break;
            case ValidatorTypes.POSITIVE:
                if (value) {
                    if (isNaN(value) || Number(value) <= 0) return { error: "Enter Positive Number!", valid: false }
                }
                break;
            case ValidatorTypes.PROJECT_TYPE_NAME:
                if (!value.split(' ').join('')) return { error: 'This Field is Required', valid: false };
                else if (!pattern.test(value)) return { error: pattern.message, valid: false };
                break;
            case ValidatorTypes.PROJECT_TYPE_CODE:
                if (!pattern.test(value)) return { error: pattern.message, valid: false };
                break;
            case ValidatorTypes.PROJECT_TYPE_PASSWORD:
                if (!passwordValidator(value)) return { error: 'Password is not valid', valid: false };
                break;
            case ValidatorTypes.MULTISELECT:
                if (value && value.length == 0) return { error: 'Select at least one option', valid: false };
                break;
            case ValidatorTypes.WEBSITE:
                if (value) {
                    const multipleURL = value.split(',');
                    for (let i = 0; i < multipleURL.length; i++) {
                        let status = websiteValidator(multipleURL[i].trim());
                        if (!status) return { error: "Please Enter Valid WebSite", valid: false };
                    }
                }
                break;
            case ValidatorTypes.SINGLE_DIGIT:
                if (value) {
                    if (Number(value) >= 10 || Number(value) <= 0) return { error: "Please Enter a value between (1-9)", valid: false };
                }
                break;
            case ValidatorTypes.MONTHS_PER_QUARTER:
                if (value) {
                    const numValue = Number(value);
                    if (isNaN(numValue) || numValue < 1 || numValue > 6) {
                        return { error: "Value must be between 1 and 6", valid: false };
                    }
                    if (numValue !== Math.floor(numValue)) {
                        return { error: "Value must be a whole number between 1 and 6", valid: false };
                    }
                }
                break;
            case ValidatorTypes.PERCENTAGE:
                if (value !== '' && value !== null && value !== undefined) {
                    const numValue = Number(value);
                    if (isNaN(numValue)) {
                        return { error: "Value must be a valid number", valid: false };
                    }
                    if (numValue < 0) {
                        return { error: "Value cannot be negative", valid: false };
                    }
                    if (numValue > 100) {
                        return { error: "Value cannot exceed 100", valid: false };
                    }
                }
                break;
            case ValidatorTypes.FIRST_NAME:
                if (value) {
                    let status = firstNameValidator(value);
                    if (!status) return { error: "FirstName must contain only characters", valid: false };
                }
                break;
            case ValidatorTypes.LAST_NAME:
                if (value) {
                    let status = lastNameValidator(value);
                    if (!status) return { error: "LastName must contain only characters", valid: false };
                }
                break;
            case ValidatorTypes.HOURLY_RATE:
                if (value) {
                    let status = hourlyRateValidator(value);
                    if (!status) return { error: "Please enter a valid positive number", valid: false };
                }
                break;
            case ValidatorTypes.PASSWORD_TYPE:
                if (value) {
                    let status = passwordTypeValidator(value);
                    if (!status) return { error: "Please select a valid password type", valid: false };
                }
                break;
            case ValidatorTypes.AVAILABLE_DAYS:
                if (value) {
                    let status = availableDaysValidator(value);
                    if (!status) return { error: "Select Available Days", valid: false };
                }
                break;
            case ValidatorTypes.PROGRESS_CLAIM_NUMBER:
                if (value) {
                    if (!/^[a-zA-Z0-9]+$/.test(String(value).trim())) {
                        return { error: "Only letters and numbers are allowed in Progress Claim Number", valid: false };
                    }
                }
                break;
            default: break;
        }
    }
    return { error, valid };
};

export const ValidatorTypes = {
    EMAIL: 'email',
    PHONE_NUMBER: 'phone_number',
    REQUIRED: "required",
    OPTIONAL: 'optional',
    ABN: 'abn',
    POSTCODE: 'postcode',
    MIN: 'min',
    MAX: 'max',
    POSITIVE: 'positive',
    SINGLE_DIGIT: 'single_digit',
    SKIP: 'skip',
    PAYMENT_TERMS: 'payment_terms',
    TEXTAREA: 'textarea',
    MIN_TWO_CHARACTERS: 'min_two_characters',
    NUMBER: 'number',
    FILE: 'file',
    PROJECT_TYPE_NAME: 'project_type_name',
    PROJECT_TYPE_CODE: 'project_type_code',
    PROJECT_TYPE_PASSWORD: 'project_type_password',
    MULTISELECT: 'multiselect',
    WEBSITE: 'website',
    MONTHS_PER_QUARTER: 'months_per_quarter',
    PERCENTAGE: 'percentage',
    POSITIVE_NUMBER: 'positive_number',
    FIRST_NAME: 'first_name',
    LAST_NAME: 'last_name',
    HOURLY_RATE: 'hourly_rate',
    PASSWORD_TYPE: 'password_type',
    AVAILABLE_DAYS: 'available_days',
    PROGRESS_CLAIM_NUMBER: 'progress_claim_number',
}